import { RecetaRepository } from "../repositories/Receta.repository"

export const RecetaService = {
    getRecetas,
    addInsumo,
    updateInsumo,
    deleteInsumo
}

async function getRecetas(data?: {}){
    const res = await RecetaRepository.get(data)
    return res
}

async function addInsumo(data: {}){
    const res = await RecetaRepository.create(data)
    return res
}

async function updateInsumo(id: number, data: {}){
    const res = await RecetaRepository.update(id, data)
    return res
}

async function deleteInsumo(id: number){
    const res = await RecetaRepository.delete(id)
    return res
}